import { render, staticRenderFns } from "./ArrowButtonNavigation.vue?vue&type=template&id=4fc58a4e&scoped=true"
import script from "./ArrowButtonNavigation.vue?vue&type=script&lang=js"
export * from "./ArrowButtonNavigation.vue?vue&type=script&lang=js"
import style0 from "./ArrowButtonNavigation.vue?vue&type=style&index=0&id=4fc58a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc58a4e",
  null
  
)

export default component.exports